import { render } from "./nahalMassha.vue?vue&type=template&id=2f7dfef2&scoped=true"
import script from "./nahalMassha.vue?vue&type=script&lang=js"
export * from "./nahalMassha.vue?vue&type=script&lang=js"

import "./nahalMassha.vue?vue&type=style&index=0&id=2f7dfef2&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7dfef2"]])

export default __exports__